import { defineComponent } from 'vue';
import { useTNodeJSX } from '../hooks/tnode';
import ChatItem from './chat-item';

import props from './props';

import type { TdChatItemProps } from './type';

export default defineComponent({
  name: 'TChatList',
  props,
  setup(props) {
    const renderTNodeJSX = useTNodeJSX();

    return () => {
      const data = renderTNodeJSX('data') || props.data;
      const textLoading = renderTNodeJSX('textLoading') || props.textLoading;
      return (
        <template>
          {data &&
            data.map((item: TdChatItemProps, index: number) => (
              <ChatItem
                avatar={item.avatar}
                name={item.name}
                role={item.role}
                datetime={item.datetime}
                content={item.content}
                text-loading={index === 0 && textLoading}
              />
            ))}
        </template>
      );
    };
  },
});
